import React from "react";
import BookingForm from "./BookingForm";


export default function PopupForm({ show, onClose }) {
    if (!show) return null;


    return (
        <div className="popup-overlay">
            <div className="popup-box">
                <h2>Book RO Service</h2>
                <BookingForm />
                <button className="popup-close" onClick={onClose}>Close</button>
            </div>
        </div>
    );
}